import React, { useEffect, useRef, useState } from "react";
// import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  getDashBoardCount,
  getDashBoardFollowups,
  // tokenCheck,
} from "./services/dashboard.services";
// import { LoadingPanel } from "../../components/layout/Loading";
import { motion } from "framer-motion";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import "./Dashboard.css";
// import { BsBookmarkPlusFill } from "react-icons/bs";
import { TbReceiptRupee } from "react-icons/tb";
import { RiInfoCardLine } from "react-icons/ri";
import { IoMdPersonAdd } from "react-icons/io";
// import { GiMoneyStack } from "react-icons/gi";
import IconComponent from "../../components/common/IconComponent";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { DateRangeFilter, EDIT_ACCESS } from "../../_contstants/common";
import { checkAcessRights, getFilterFromToDate } from "../../_helper/helper";
import {
  setActiveTabIndex,
  setDateFilter,
  setFolloupID,
} from "./dashboardSlice";
import { Link, useNavigate } from "react-router-dom";
import { updateFollowUpStatus } from "../inquiry/services/inquiry.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { opened } from "../../components/drawer/drawerSlice";
import { IDrawerState } from "../../components/drawer/drawerModel";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { RxCross1 } from "react-icons/rx";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormTextArea from "../../components/formFields/FormTextArea";
import IconButton from "../../components/common/IconButton";

ChartJS.register(ArcElement, Tooltip, Legend);

const DashBoardCardData = [
  // {
  //   title: "Bookings",
  //   icon: <IconComponent icon={BsBookmarkPlusFill} />,
  //   link: "dashboard/booking",
  // },
  {
    title: "Quotations",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/quotation",
  },
  {
    title: "Inquiries",
    icon: <IconComponent icon={RiInfoCardLine} />,
    link: "dashboard/inquiry",
  },
  {
    title: "Leads",
    icon: <IconComponent icon={IoMdPersonAdd} />,
    link: "dashboard/lead",
  },
];

const getDashboardCardData = (title: string, type: "icon" | "link") => {
  const item = DashBoardCardData.find((data) => data.title === title);
  if (!item) return null;

  return type === "icon" ? item.icon : item.link || "#";
};

// const DashboardIcons: any = {
//   Leads: <IconComponent icon={IoMdPersonAdd} />,
//   Inquiries: <IconComponent icon={RiInfoCardLine} />,
//   Quotations: <IconComponent icon={TbReceiptRupee} />,
//   Bookings: <IconComponent icon={BsBookmarkPlusFill} />,
// };

interface DateFilterChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DateFilterChangeWatcher: React.FC<DateFilterChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const SelectedDate = formRenderProps.valueGetter("SelectedDate");
  const FromDate = formRenderProps.valueGetter("FromDate");
  const ToDate = formRenderProps.valueGetter("ToDate");
  const next15Days = new Date(new Date().setDate(new Date().getDate() + 15));

  useEffect(() => {
    if (SelectedDate !== 6) {
      formRenderProps.onChange("FromDate", { value: null });
      formRenderProps.onChange("ToDate", { value: null });
      const filter = getFilterFromToDate(SelectedDate);
      if (filter.FromDate === "" && filter.ToDate === "") {
        const DefaultDate = {
          FromDate: moment(new Date()).format("YYYY-MM-DD"),
          ToDate: moment(next15Days).format("YYYY-MM-DD"),
        };
        dispatch(getDashBoardCount(DefaultDate));
        dispatch(getDashBoardFollowups(DefaultDate));
        dispatch(setDateFilter({ SelectedDate, ...DefaultDate }));
      } else {
        dispatch(getDashBoardCount(filter));
        dispatch(getDashBoardFollowups(filter));
        dispatch(setDateFilter({ SelectedDate, ...filter }));
      }
    }
  }, [SelectedDate]);

  useEffect(() => {
    const filter = {
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD")
        : moment(new Date()).format("YYYY-MM-DD"),
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : moment(next15Days).format("YYYY-MM-DD"),
    };
    if (FromDate && ToDate) {
      dispatch(getDashBoardCount(filter));
      dispatch(getDashBoardFollowups(filter));
      dispatch(setDateFilter({ SelectedDate, ...filter }));
    }
  }, [FromDate, ToDate]);
  return null;
};

const Dashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const gridRef = useRef<any>(null);
  const gridFOrmLoadingRef = useRef<any>(null);
  const DashBoardCountList = useAppSelector(
    (state) => state.dashboard.DashBoardCountList
  );
  const DashboardInquiryFollowups = useAppSelector(
    (state) => state.dashboard.DashboardInquiryFollowups
  );
  const DashboardLeadFollowups = useAppSelector(
    (state) => state.dashboard.DashboardLeadFollowups
  );
  const isLeadEditAccess = checkAcessRights("/lead", EDIT_ACCESS);
  const isInquiryEditAccess = checkAcessRights("/inquiry", EDIT_ACCESS);

  const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);
  const formatedDateFilter = {
    ...dateFilter,
    FromDate: dateFilter.FromDate
      ? moment(dateFilter?.FromDate, "YYYY-MM-DD").toDate()
      : "",
    ToDate: dateFilter.ToDate
      ? moment(dateFilter?.ToDate, "YYYY-MM-DD").toDate()
      : "",
  };

  const loading = useAppSelector((state) => state.dashboard.loading);
  const followUpLoading = useAppSelector(
    (state) => state.dashboard.followUpLoading
  );
  const loginDetails = useAppSelector((state) => state.login.loginDetails);

  // useEffect(() => {
  //   dispatch(tokenCheck());
  // }, []);

  // const stats = [
  //   {
  //     title: "Bookings",
  //     count: 120,
  //     icon: <IconComponent icon={BsBookmarkPlusFill} />,
  //   },
  //   {
  //     title: "Quotations",
  //     count: 85,
  //     icon: <IconComponent icon={TbReceiptRupee} />,
  //   },
  //   {
  //     title: "Inquiries",
  //     count: 45,
  //     icon: <IconComponent icon={RiInfoCardLine} />,
  //   },
  //   {
  //     title: "Leads",
  //     count: 200,
  //     icon: <IconComponent icon={IoMdPersonAdd} />,
  //   },
  // ];

  // const leadFollowUps = [
  //   {
  //     id: 1,
  //     name: "Sarah Connor",
  //     date: "2025-02-27",
  //     time: "10:30 AM",
  //     description: "Interested in a Paris trip package",
  //   },
  //   {
  //     id: 2,
  //     name: "Michael Scott",
  //     date: "2025-02-28",
  //     time: "09:15 AM",
  //     description: "Needs quote for New York business trip",
  //   },
  //   {
  //     id: 4,
  //     name: "Jim Halpert",
  //     date: "2025-03-02",
  //     time: "02:30 PM",
  //     description: "Wants to book a Tokyo tour",
  //   },
  //   {
  //     id: 6,
  //     name: "Angela Martin",
  //     date: "2025-03-04",
  //     time: "01:00 PM",
  //     description: "Interested in a London luxury trip",
  //   },
  // ];

  // const inquiryFollowUps = [
  //   {
  //     id: 3,
  //     name: "Pam Beesly",
  //     date: "2025-03-01",
  //     time: "11:00 AM",
  //     description: "Inquiry about Bali honeymoon package",
  //   },
  //   {
  //     id: 5,
  //     name: "Dwight Schrute",
  //     date: "2025-03-03",
  //     time: "03:45 PM",
  //     description: "Request for a rural farm stay package",
  //   },
  // ];

  const [activeTab, setActiveTab] = useState<"Lead" | "Inquiry">("Lead");

  const displayedFollowUps =
    activeTab === "Lead" ? DashboardLeadFollowups : DashboardInquiryFollowups;

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        duration: 0.5,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const pieData = {
    labels: DashBoardCountList?.filter(
      (count: any) => count?.Title !== "Bookings"
    )?.map((e) => e?.Title),
    datasets: [
      {
        data: DashBoardCountList?.filter(
          (count: any) => count?.Title !== "Bookings"
        )?.map((card) => card.TotalCount),
        backgroundColor: [
          "#174583",
          "#4EBECF",
          "#17458380",
          //  "#4EBECF80"
        ],
        borderColor: [
          "#174583",
          "#4EBECF",
          "#174583",
          //  "#4EBECF"
        ],
        borderWidth: 2,
        hoverOffset: 5,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    plugins: {
      legend: {
        position: "bottom" as const,
        labels: {
          color: "#333",
          font: { size: 14, weight: "bold" as const },
          padding: 20,
          boxWidth: 20,
          boxHeight: 20,
        },
      },
      tooltip: {
        backgroundColor: "#174583",
        titleColor: "white",
        bodyColor: "white",
        borderColor: "#4EBECF",
        borderWidth: 1,
        caretSize: 0,
        padding: 10,
        bodyFont: { size: 12 },
      },
    },
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 1000,
    },
    hover: {
      mode: "nearest" as const,
      intersect: true,
    },
    onHover: (event: any, chartElement: any) => {
      event.native.target.style.cursor = chartElement[0]
        ? "pointer"
        : "default";
    },
  };

  const today = moment(new Date()).format("YYYY-MM-DD");
  const next15Days = moment(
    new Date(new Date().setDate(new Date().getDate() + 15))
  ).format("YYYY-MM-DD");

  const handleEditLeadOrInquiry = async (data: any) => {
    if (data?.FollowupType === "LEAD" && isLeadEditAccess) {
      const drawerOptions: IDrawerState = {
        open: true,
        anchor: "right",
        name: "leadForm",
        drawerWidth: 400,
        data: data?.LeadID ? +data?.LeadID : null,
      };
      dispatch(opened(drawerOptions));
    } else if (data?.FollowupType === "INQUIRY" && isInquiryEditAccess) {
      navigate("inquiry/edit", {
        state: {
          InquiryID: data?.InquiryID ? +data?.InquiryID : null,
        },
      });
    }
  };

  const handleOpenCompleteFollowupDialog = (ID: number) => {
    dispatch(openDialog("completeFollowup"));
    dispatch(setFolloupID(ID));
  };

  const handleRedirect = (active: string) => {
    dispatch(setActiveTabIndex(active === "Lead" ? 0 : 1));
    navigate("dashboard/follow-ups", {
      state: {
        activeTab: active === "Lead" ? 0 : 1,
        FromDate: dateFilter?.FromDate,
        ToDate: dateFilter?.ToDate,
      },
    });
  };

  return (
    <>
      <FollowupCompleteDialog />
      {loading ? (
        <LoadingPanel gridRef={gridRef} />
      ) : (
        <div className="dashboard-container">
          <motion.div
            className="hero-banner"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Welcome back, {loginDetails?.FullName}!</h1>
            <p>Explore Ajay Modi Pvt. Ltd. Dashboard</p>
          </motion.div>
          <motion.div
            className="dates-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.1, duration: 0.5 }}
          >
            <Form
              onSubmit={() => {}}
              initialValues={formatedDateFilter}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ width: "100%" }}>
                  <GridLayout
                    style={{ marginRight: 40 }}
                    gap={{ rows: 20, cols: 20 }}
                    cols={[
                      { width: "33.33%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem>
                      <Typography.h4 style={{ margin: 0 }}>
                        My Dashboard
                      </Typography.h4>
                    </GridLayoutItem>
                    <GridLayoutItem></GridLayoutItem>
                    <GridLayoutItem className="d-flex justify-content-end align-items-center ">
                      {formRenderProps.valueGetter("SelectedDate") ? (
                        ""
                      ) : (
                        <span style={{ whiteSpace: "nowrap" }}>
                          Next 15 Days Data!
                        </span>
                      )}
                      {formRenderProps.valueGetter("SelectedDate") === 6 && (
                        <>
                          <Field
                            wrapperStyle={{
                              margin: "0 0 0 10px",
                              width: 150,
                              flex: "none",
                            }}
                            name="FromDate"
                            component={FormDatePicker}
                            format={"dd/MM/yyyy"}
                            placeholder="From Date"
                          />
                          <Field
                            wrapperStyle={{
                              margin: "0 0 0 10px",
                              width: 150,
                              flex: "none",
                            }}
                            name="ToDate"
                            component={FormDatePicker}
                            format={"dd/MM/yyyy"}
                            minDate={moment(
                              formRenderProps.valueGetter("FromDate")
                            ).toDate()}
                            disabled={
                              formRenderProps.valueGetter("FromDate")
                                ? false
                                : true
                            }
                            placeholder="To Date"
                          />
                        </>
                      )}
                      <Field
                        wrapperStyle={{
                          margin: "0 0 0 10px",
                          width: 200,
                          flex: "none",
                        }}
                        name="SelectedDate"
                        component={FormSelectionField}
                        size={"small"}
                        placeholder="Filter"
                        options={DateRangeFilter?.map((date: any) => {
                          return {
                            value: date.value,
                            label: date.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                  <DateFilterChangeWatcher formRenderProps={formRenderProps} />
                </FormElement>
              )}
            />
          </motion.div>
          <div className="stats-grid">
            {DashBoardCountList?.filter(
              (count: any) => count?.Title !== "Bookings"
            )?.map((card, index) => (
              <Link
                to={
                  !card.TotalCount
                    ? "#"
                    : (getDashboardCardData(card.Title, "link") as string)
                }
                state={{
                  filter: {
                    FromDate: dateFilter?.FromDate || today,
                    ToDate: dateFilter?.ToDate || next15Days,
                  },
                }}
                style={{
                  textDecoration: "none",
                  height: "100%",
                  display: "block",
                }}
              >
                <motion.div
                  key={card.Title}
                  className="stat-card"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.2, duration: 0.5 }}
                >
                  <span className="stat-icon">
                    {getDashboardCardData(card.Title, "icon")}
                  </span>
                  <div className="state-card-text">
                    <h3>{card.Title}</h3>
                    <p>{card.TotalCount}</p>
                  </div>
                </motion.div>
              </Link>
            ))}
          </div>
          <div className="main-content">
            <motion.div
              className="followups-card position-relative"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              {followUpLoading ? (
                <LoadingPanel gridRef={gridFOrmLoadingRef} />
              ) : (
                <>
                  <h2>Follow-ups</h2>
                  <div className="followups-tabs">
                    <motion.button
                      className={`tab-btn ${
                        activeTab === "Lead" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Lead")}
                      whileHover={{
                        scale: 1.05,
                        transition: { duration: 0.2 },
                      }}
                      whileTap={{ scale: 0.95 }}
                    >
                      Leads
                    </motion.button>
                    <motion.button
                      className={`tab-btn ${
                        activeTab === "Inquiry" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Inquiry")}
                      whileHover={{
                        scale: 1.05,
                        transition: { duration: 0.2 },
                      }}
                      whileTap={{ scale: 0.95 }}
                    >
                      Inquiries
                    </motion.button>
                  </div>
                  <motion.ul
                    className="followups-list"
                    variants={listVariants}
                    initial="hidden"
                    animate="visible"
                    key={activeTab}
                  >
                    {displayedFollowUps?.length > 0 ? (
                      displayedFollowUps.slice(0, 3).map((followUp) => (
                        <motion.li
                          key={followUp.ID}
                          className="followup-item"
                          variants={itemVariants}
                          style={{ padding: "4px" }}
                          onClick={() => handleEditLeadOrInquiry(followUp)}
                        >
                          <div className="followup-header">
                            <span className="lead-name">{followUp.Name}</span>
                            <span className="followup-date-time">
                              {followUp.FollowupDate} | {followUp.FollowupTime}
                            </span>
                          </div>
                          <div className="followup-header gap-2">
                            <p className="followup-description">
                              {followUp.Remarks}
                            </p>
                            <span className="followup-date-time">
                              <motion.button
                                className={`tab-btn active`}
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  handleOpenCompleteFollowupDialog(
                                    followUp?.ID || 0
                                  );
                                }}
                                whileHover={{
                                  scale: 1.05,
                                  transition: { duration: 0.2 },
                                }}
                                whileTap={{ scale: 0.95 }}
                                style={{ padding: "5px 10px" }}
                              >
                                Complete
                              </motion.button>
                            </span>
                          </div>
                        </motion.li>
                      ))
                    ) : (
                      <motion.p key="no-followups" className="no-followups">
                        No follow-ups found for selected date range.
                      </motion.p>
                    )}
                  </motion.ul>
                  {displayedFollowUps?.length > 3 && (
                    <motion.button
                      className="see-more-btn"
                      whileHover={{ scale: 1.05, backgroundColor: "#14386f" }} // Updated hover effect
                      whileTap={{ scale: 0.95 }}
                      transition={{ duration: 0.2 }}
                      type="button"
                      onClick={() => handleRedirect(activeTab)}
                    >
                      See More
                    </motion.button>
                  )}
                </>
              )}
            </motion.div>
            <motion.div
              className="pie-chart-card"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2>Overview</h2>
              <div className="chart-container">
                <Pie data={pieData} options={pieOptions} />
              </div>
            </motion.div>
          </div>
        </div>
      )}
    </>
  );
};

const FollowupCompleteDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const followUpLoading = useAppSelector(
    (state) => state.dashboard.followUpLoading
  );
  const followupId = useAppSelector((state) => state.dashboard.followupId);
  const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);

  const handleSubmit = async (values: any) => {
    const payload = {
      ID: followupId ? +followupId : null,
      CompletedRemarks: values?.CompletedRemarks
        ? values?.CompletedRemarks
        : "",

      IsCompleted: true,
    };
    if (followupId) {
      const res = await dispatch(updateFollowUpStatus(payload));
      if (res.meta.requestStatus === "fulfilled") {
        const filter = {
          FromDate: dateFilter.FromDate || "",
          ToDate: dateFilter.ToDate || "",
        };
        dispatch(getDashBoardFollowups(filter));
        dispatch(closeDialog());
      }
    }
  };

  return (
    <>
      {dialogName === "completeFollowup" && (
        <AppDialog>
          <>
            {followUpLoading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 500 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Complete Followup"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        id={"CompletedRemarks"}
                        name={"CompletedRemarks"}
                        label={"Completed Remarks"}
                        placeholder={"Completed Remarks"}
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: 20,
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonWithLoading
                        label={"Complete"}
                        type="submit"
                        disabled={
                          !formRenderProps.allowSubmit || followUpLoading
                        }
                        loading={followUpLoading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Dashboard;
